import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { Picture } from '@/components/wpl/image/src/image';
import { Video } from '@/components/wpl/video/src/video';
import { Row } from '@/libraries/wpl/foundations/src/grid';

const HeroVideo = () => {
	return (
		<Row layout="12">
			<div css={container}>
				<Picture
					css={bgImage}
					image={{
						alt: '',
						src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eskxgojb0g32x168w8yg8g7g2586005n.svg',
					}}
				/>
				<Video
					loop
					muted
					// existing video that is low priority to move over to brandfolder
					// eslint-disable-next-line local/no-non-orangelogic-images-eslint
					videoLink="https://wac-cdn.atlassian.com/misc-assets/videos/jira-product-discovery/JPD_product-tour_hero.mp4"
					css={video}
				/>
			</div>
		</Row>
	);
};

export default HeroVideo;

const container = css({
	display: 'grid',
	placeItems: 'center',
	marginBlockStart: token('space.negative.200'),
	marginBlockEnd: token('space.400'),
	[media.above.sm]: {
		marginBlockEnd: token('space.800'),
	},
});
const video = css({
	overflow: 'clip',
	aspectRatio: '16 / 9',
	borderRadius: '.5rem',
	// eslint-disable-next-line local/ensure-wac-token-usage
	filter: 'drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.3))',
	gridColumn: '1 / 1',
	gridRow: '1 / 1',
	transform: `translateY(${token('space.100')})`,
	[media.only.sm]: {
		transform: `translateY(${token('space.200')})`,
	},
	[media.above.sm]: {
		transform: `translateY(${token('space.300')})`,
	},
});
const bgImage = css({
	transform: 'scale(1.1)',
	gridColumn: '1 / 1',
	gridRow: '1 / 1',
	width: '99%',
});
